






















































































/* eslint-disable max-len */
// import { getHumanDateFromUnixTimestamp } from '@/lib/utils/getHumanDateFromUnixTimeStamp'
import {
  defineComponent, reactive, toRefs, PropType, // computed, ComputedRef,
} from '@vue/composition-api'
import Pod from '@/components/layouts/Pod.vue'
import PodCard from '@/components/layouts/PodCard.vue'
import DeleteSessionModal from '@/components/clientflow/DeleteSessionModal.vue'
import { vxm } from '@/state/index'
import SessionForm from './SessionForm.vue'

/**
 * TODO: this is just copy paste .. dont need remote here, fix it later
 * Shape of the data, that we get from vuex store.
 * TODO: put this definition somewhere in the store.
 */
interface RemoteSessionData {
  date: string;
  clientId: string;
  therapistId: string;
  note?: string;
  localReference?: string;
}

type LocalSessionData = RemoteSessionData & {
  dateObj: Date;
  id: string;
}

type State = {
  loading: boolean;
  editToggle: boolean;
  editing: boolean;
  showDeleteSessionModal: boolean;
}

const initialState: State = {
  loading: true,
  editToggle: false,
  editing: false,
  showDeleteSessionModal: false,
}

export default defineComponent({
  components: {
    Pod, PodCard, SessionForm, DeleteSessionModal,
  },
  props: {
    session: {
      type: Object as PropType<LocalSessionData>,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    clientName: {
      type: String,
      required: true,
    },
    sessionNo: {
      type: Number,
      required: true,
    },

  },

  setup(props, context) {
    // Set up state
    const state = reactive({ ...initialState })

    const capitalize = (s: string) => {
      if (typeof s !== 'string') return ''
      return s.charAt(0).toUpperCase() + s.slice(1)
    }

    const getFormattedDate = (date: Date) => date.toLocaleDateString(
      context.root.$vuetify.lang.current,
      {
        weekday: 'short', year: 'numeric', month: 'short', day: 'numeric',
      },
    )

    const getDaysBtw = (from: Date, to: Date): number => Math.floor((to.getTime() - from.getTime()) / 86400000)

    function getMonthsDiff(from: Date, to: Date) {
      const date1 = new Date(from)
      const date2 = new Date(to)
      const years = to.getFullYear() - from.getFullYear()
      const months = (years * 12) + (date2.getMonth() - date1.getMonth())
      return months
    }

    const getTimePassedMsg = (from: Date, to: Date): string => {
      if (from.toISOString().substr(0, 10) === to.toISOString().substr(0, 10)) {
        return 'i dag'
      }
      const daysBtw = getDaysBtw(from, to)
      if (daysBtw === 1) return 'i går'
      if (daysBtw < 93) return `${daysBtw} dage siden`

      if (daysBtw < 365) {
        return `ca. ${Math.floor(getMonthsDiff(from, to))} mdr siden`
      }
      return 'mere end et år siden'
    }

    const deleteSession = () => {
      state.showDeleteSessionModal = true
    }

    const onSessionDeleted = () => {
      state.showDeleteSessionModal = false
      vxm.app.displaySnackBar({
        color: 'success',
        text: 'sessionen blev slettet',
      })
    }

    const onCancelSessionDelete = () => {
      state.showDeleteSessionModal = false
    }

    /** reactive get client from store */
    // const sessions: ComputedRef<Sessions> = computed(() => context.root.$store.getters['clientSessions/all'])

    // onBeforeMount(() => { })

    // Make stuff available for the template
    return {
      // from self
      ...toRefs(state),
      getFormattedDate,
      getTimePassedMsg,
      capitalize,
      deleteSession,
      onSessionDeleted,
      onCancelSessionDelete,

      // sessions,

    }
  },
})

